export default "__VITE_ASSET__BE3oG9e2__"